import {IValidationRules} from 'entities/metadata';
import {TReportConfigurationQueryParameterVariableType} from 'store/slices/report-configuration-slice/report-configuration-dto';
import {ETableReportFilterFieldType} from 'store/slices/table-report-slice/table-report-slice-types';

export const filterDefaultWidthResolver = (type: TReportConfigurationQueryParameterVariableType) => {
    switch (type) {
    case ETableReportFilterFieldType.STRING:
        return 292;
    case ETableReportFilterFieldType.INTEGER:
    case ETableReportFilterFieldType.NUMBER:
        return 140;
    case ETableReportFilterFieldType.DATE:
        return 140;
    case ETableReportFilterFieldType.DATETIME:
        return 200;
    case ETableReportFilterFieldType.VALUE_SET:
    case ETableReportFilterFieldType.MULTI_VALUE_SET:
    case ETableReportFilterFieldType.SQL_VALUE_SET:
    case ETableReportFilterFieldType.SQL_MULTI_VALUE_SET:
        return 250;
    default:
        return undefined;
    }
};

export const tableReportFilterFieldValidationResolver = (type: TReportConfigurationQueryParameterVariableType) => {
    const rules: IValidationRules[] = [];
    if (type === ETableReportFilterFieldType.INTEGER) {
        rules.push({regExp: '^-{0,1}[\\d]+$', errorMessage: 'Поле должно содержать только цифры'});
    }
    if (type === ETableReportFilterFieldType.NUMBER) {
        rules.push({
            regExp: '^[-]?([0-9]*[.])?[0-9]+$',
            errorMessage: 'Поле должно содержать только числовое значение',
        });
    }
    return rules;
};
